import { render, staticRenderFns } from "./shape-search.vue?vue&type=template&id=3e1524c0&scoped=true&"
import script from "./shape-search.vue?vue&type=script&lang=js&"
export * from "./shape-search.vue?vue&type=script&lang=js&"
import style0 from "./shape-search.vue?vue&type=style&index=0&id=3e1524c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1524c0",
  null
  
)

export default component.exports